import * as Const from '../constants';
import State from '../interfaces/state/SignUpState';

const initState: State = {
  isLoading: false,
  isError: false,
  userName: '',
  email: '',
  isRedirectToLogIn: false,
};

export default function signUp(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.SIGNUP_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.SIGNUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };

    case Const.SIGNUP_EMAIL:
      return {
        ...state,
        isLoading: false,
        isError: false,
        email: action.payload,
      };

    case Const.SIGNUP_USER_NAME:
      return {
        ...state,
        isError: false,
        isLoading: false,
        userName: action.payload,
      };

    case Const.SIGNUP_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.SIGNUP_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.SIGNUP_SUCCESS_RED_TO_LOG_IN:
      return {
        ...state,
        isRedirectToLogIn: true,
      };

    case Const.SIGNUP_REDIRECT_DEFAULT:
      return {
        ...state,
        isRedirectToLogIn: false,
      };

    default:
      return state;
  }
}
